var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import useRegistrationForm from "../../../../../hooks/useRegistrationForm";
import { useState } from "react";
import { MSD_SPECIALTIES_OPTIONS } from "../../../../../utils/constants";
export var enrichRegistrationFormPropsMsdTypeAll = function (_a) {
    var _b = _a === void 0 ? {} : _a, showEpisodesSelect = _b.showEpisodesSelect;
    var _c = useState(false), showAllInputs = _c[0], setShowAllInputs = _c[1];
    // Check on declared evt code for feature request
    var onChange = function (changed) {
        if (!showAllInputs && (changed["country_id"] !== undefined || changed["is_internal"] !== undefined)) {
            setShowAllInputs(true);
        }
    };
    var _d = useRegistrationForm(), contents = _d.contents, allCountries = _d.allCountries, eventCountries = _d.eventCountries, hasInternal = _d.hasInternal, isInternalUser = _d.isInternalUser, languages = _d.languages, episodes = _d.episodes, getRegistrationFormProps = _d.getRegistrationFormProps;
    var _e = contents, error_country_required = _e.error_country_required, error_lastname_required = _e.error_lastname_required, error_firstname_required = _e.error_firstname_required, error_language_required = _e.error_language_required, email = _e.email, affiliation = _e.affiliation, phone = _e.phone, country_of_work = _e.country_of_work, language = _e.language, internal = _e.internal, firstname = _e.firstname, lastname = _e.lastname, country = _e.country, choose_password_title = _e.choose_password_title, error_affiliation_required = _e.error_affiliation_required, error_specialty_required = _e.error_specialty_required, password_confirmation = _e.password_confirmation, error_password_required = _e.error_password_required, error_psw_do_not_match = _e.error_psw_do_not_match, specialty = _e.specialty, error_email_invalid = _e.error_email_invalid, error_email_required = _e.error_email_required, internal_true_value_label = _e.internal_true_value_label, internal_false_value_label = _e.internal_false_value_label, chose_episode_reg_form_label = _e.chose_episode_reg_form_label, chose_episode_reg_form_helper_label = _e.chose_episode_reg_form_helper_label;
    var inputs = [];
    if (hasInternal) {
        inputs.push({
            type: "select",
            label: internal,
            required: true,
            name: "is_internal",
            rules: [
                {
                    required: true,
                    message: ""
                }
            ],
            options: [
                {
                    value: 1,
                    label: internal_true_value_label
                },
                {
                    value: 0,
                    label: internal_false_value_label
                }
            ]
        });
    }
    var countriesSelect = {
        type: "select",
        label: country,
        required: true,
        showSearch: true,
        name: "country_id",
        rules: [
            {
                required: true,
                message: error_country_required
            }
        ],
        options: eventCountries
    };
    if (isInternalUser) {
        countriesSelect = {
            type: "select",
            label: country_of_work,
            required: true,
            showSearch: true,
            name: "country_id_of_work",
            rules: [
                {
                    required: true,
                    message: error_country_required
                }
            ],
            options: allCountries
        };
    }
    inputs.push(countriesSelect);
    var languageInput = {
        type: "hidden",
        name: "lang_id",
        value: languages[0].value
    };
    if (languages.length > 1) {
        languageInput = {
            type: "select",
            label: language,
            required: true,
            name: "lang_id",
            options: languages,
            rules: [
                {
                    required: true,
                    message: error_language_required
                }
            ]
        };
    }
    inputs.push(languageInput);
    if (showAllInputs) {
        inputs = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], inputs, true), [
            {
                type: "text",
                label: firstname,
                required: true,
                name: "firstname",
                rules: [
                    {
                        required: true,
                        message: error_firstname_required
                    }
                ]
            },
            {
                type: "text",
                label: lastname,
                required: true,
                name: "lastname",
                rules: [
                    {
                        required: true,
                        message: error_lastname_required
                    }
                ]
            },
            {
                label: specialty,
                name: "specialty",
                options: MSD_SPECIALTIES_OPTIONS,
                required: true,
                type: "select",
                rules: [
                    {
                        required: true,
                        message: error_specialty_required
                    }
                ]
            }
        ], false), (showEpisodesSelect
            ? [
                {
                    type: "select",
                    label: (_jsxs("span", { children: [chose_episode_reg_form_label || "Which session(s) are you interested in?", chose_episode_reg_form_helper_label && (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsx("span", __assign({ className: "form-label-helper" }, { children: chose_episode_reg_form_helper_label }))] }))] })),
                    required: false,
                    name: "utm_source",
                    mode: "multiple",
                    options: episodes === null || episodes === void 0 ? void 0 : episodes.map(function (episode) {
                        return {
                            id: String(episode.id),
                            value: episode.title || "",
                            label: episode.evaluation_form_title || episode.title || ""
                        };
                    })
                }
            ]
            : []), true), [
            {
                type: "text",
                label: affiliation,
                required: true,
                name: "affiliation",
                rules: [
                    {
                        required: true,
                        message: error_affiliation_required
                    }
                ]
            },
            {
                type: "email",
                label: email,
                required: true,
                name: "email",
                rules: [
                    { type: "email", message: error_email_invalid },
                    {
                        required: true,
                        message: error_email_required
                    }
                ]
            },
            {
                type: "password",
                label: choose_password_title || "Choose your password",
                required: true,
                name: "password",
                rules: [
                    {
                        required: true,
                        message: error_password_required
                    }
                ]
            },
            {
                type: "password",
                label: password_confirmation,
                required: true,
                name: "password_confirmation",
                rules: [
                    {
                        required: true,
                        message: error_psw_do_not_match
                    }
                ]
            },
            {
                type: "text",
                label: phone,
                name: "phone"
            },
            {
                type: "hidden",
                name: "change_password_required",
                value: false
            }
        ], false);
    }
    return {
        inputs: getRegistrationFormProps({ inputs: inputs }).inputs,
        onChange: function (changedValues) {
            getRegistrationFormProps({ inputs: inputs }).onChange(changedValues);
            onChange(changedValues);
        }
    };
};
